import React, { useEffect, useState } from 'react';
import {
  CarouselContainer,
  CarouselContentWrapper,
  CarouselContent,
  Arrow,
  CarouselWrapper,
} from './HorizantalScroller.style';

const Carousel = (props) => {
  const { children, show } = props;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [length, setLength] = useState(children.length);

  const [touchPosition, setTouchPosition] = useState(null);

  // Set the length to match current children from props
  useEffect(() => {
    setLength(children.length);
  }, [children]);

  const next = () => {
    if (currentIndex < (length - show)) {
      setCurrentIndex(prevState => prevState + 1);
    }
  };

  const prev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(prevState => prevState - 1);
    }
  };

  const handleTouchStart = (e) => {
    const touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };

  const handleTouchMove = (e) => {
    const touchDown = touchPosition;

    if (touchDown === null) {
      return;
    }

    const currentTouch = e.touches[0].clientX;
    const diff = touchDown - currentTouch;

    if (diff > 5) {
      next();
    }

    if (diff < -5) {
      prev();
    }

    setTouchPosition(null);
  };

  return (
    <CarouselContainer>
      <CarouselWrapper>
        <Arrow type="button" onClick={prev} className="left-arrow" leftArrow>
          <img
            src={`/images/icon-svg/${'arrow-right.svg'}`}
            alt="arrow"
          />
        </Arrow>
        <CarouselContentWrapper
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
        >
          <CarouselContent
            className={`carousel-content show-${show}`}
            style={{ transform: `translateX(-${currentIndex * (100 / show)}%)` }}
          >
            {children}
          </CarouselContent>
        </CarouselContentWrapper>

        <Arrow type="button" onClick={next} className="right-arrow">
          <img
            src={`/images/icon-svg/${'arrow-right.svg'}`}
            alt="arrow"
          />
        </Arrow>
      </CarouselWrapper>
    </CarouselContainer>
  );
};

export default Carousel;
